import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { analyticsUtils } from 'utils';
import { cn } from 'utils/classnames';
import { CopyIcon } from '@fronton/icons-react';
import { getStoreDetail } from 'features/store/ducks/get-store-by-id';
import { SHOW_COPY_SNACK } from './snack-helper';
import { addressBlock, addressLine, copyIconStyle } from './styles';

type Props = {
  className?: string;
  blockName?: string;
};

export const StoreAddress: FC<Props> = ({ className = undefined, blockName }) => {
  const { address } = useSelector(getStoreDetail) || {};
  const copyAddress = useCallback(() => {
    document.dispatchEvent(new Event(SHOW_COPY_SNACK));

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'shopPage', // блок, в котором расположен элемент
      elementName: blockName, // название блока
      elementText: 'Адрес скопирован',
    });

    return navigator.clipboard.writeText(address || '');
  }, [address, blockName]);
  return (
    <div
      className={cn(className, addressBlock)}
      onClick={copyAddress}
      onKeyDown={copyAddress}
      data-qa="store-address"
      itemScope
      itemType="https://schema.org/PostalAddress"
    >
      <Typography
        data-qa="address-row"
        color="text-primary"
        size="body_long"
        variant="m"
        className={addressLine}
      >
        {address}
      </Typography>
      <CopyIcon color="text-primary" data-qa="copy-button" className={copyIconStyle} size="l" />
    </div>
  );
};
